{
  "email-templates": "Email Templates",
  "template-list": "Email Templates",
  "notification-updated": "Notification updated",
  "title": "Delete Notification",
  "confirmationMessage": "Are you sure you want to delete this notification? This action cannot be undone.",
  "title-create": "Create Email Template",
  "title-edit": "Edit Email Template",
  "subject": "Subject",
  "notification-deleted": "Notification Deleted",
  "notification-created": "Notification Created",
  "text": "Text",
  "prompt": "Prompt",
  "add-template": "Add Template",
  "delete-template": "Delete Template",
  "no-templates": "No templates yet",
  "loading": "Loading templates...",
  "load-error": "We couldn't load the templates.",
  "retry": "Retry",
  "compose": "Compose",
  "preview": "Preview"
}
